import React from 'react';
import Hidden from '@material-ui/core/Hidden';
import { Box } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  logo: {
    maxHeight: 56,
    width: 'auto',
    objectFit: 'contain',
  },
  logoSm: {
    maxHeight: 40,
    width: 'auto',
    objectFit: 'contain',
  },
});

const Logo = ({ color, ...props }) => {
  const classes = useStyles();
  const logoUrl = color === 'white' ? '/images/logo-white.png' : '/images/logo.png';

  return (
    <Box className="pointer" {...props}>
      <Hidden xsDown>
        <NavLink to="/">
          <CmtImage src={logoUrl} alt="Shimanto Bank" className={classes.logo} />
        </NavLink>
      </Hidden>
      <Hidden smUp>
        <NavLink to="/">
          <CmtImage src={logoUrl} alt="Shimanto Bank" className={classes.logoSm} />
        </NavLink>
      </Hidden>
    </Box>
  );
};

export default Logo;
